/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { fromJS } from 'immutable';
import { LOCATION_CHANGE } from 'react-router-redux';

import globalReducer from 'Application/reducer';
import localStorageReducer from 'domain/LocalStorage/reducer';

/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@5
 *
 */

// Initial routing state
const routeInitialState = fromJS({
  lastLocation: null,
  location: null,
});

/**
 * Merge route into the global application state
 */
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE: {
      return state.merge({
        location: action.payload,
        lastLocation: state.get('location'),
      });
    }
    default:
      return state;
  }
}

const reducerCombiner = (reducers) => {
  const keys = Object.keys(reducers);

  return (fullState = Map(), action) => {
    return fullState.withMutations((temp) => {
      keys.forEach((key) => {
        const reducerState = temp.get(key);
        temp.set(key, reducers[key](reducerState, action, fullState));
      });
    });
  };
};

/**
 * Creates the main reducer with the asynchrdynamically injected ones
 */
export default function createReducer(injectedReducers) {
  return reducerCombiner({
    route: routeReducer,
    application: globalReducer,
    localStorage: localStorageReducer,
    ...injectedReducers,
  });
}
